import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
// Reducer Thunk
export const getTonKhoAVP = createAsyncThunk('TonKhoAVP/getTonKhoAVP', async () => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).get(`api/report/tonKhoAVP`)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})
export const getInStock = createAsyncThunk('keepStock/getInStock', async () => {
    try {
        let response
        let docList

        const req = { UserId: 1 }
        response = await axios.create(axiosConfig).post(`api/report/InStock`, req)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})
// 
export const getTonKhoBatch = createAsyncThunk('TonKhoAVP/getTonKhoBatch', async (loadparam) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/TonKhoBatch`, loadparam)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})
const TonKhoAVPSlice = createSlice({
    name: 'TonKhoAVP',
    initialState: {
        allPageLoad: [],
        TonKhoBatch: [],
        InStock: [],
        InStockByPro2: [],
        InStockByPro4: [],
        InStockByPro2_4: [],
        Loading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getTonKhoAVP.pending, (state, action) => {
            console.log('Fetching todos from backend ....')
            state.Loading = true
        })
        builder.addCase(getTonKhoAVP.fulfilled, (state, action) => {
            console.log('Done')
            state.allPageLoad = action.payload
            state.Loading = false
        })
        builder.addCase(getTonKhoAVP.rejected, (state, action) => {
            console.log('Failed to get todos!!!')
            state.Loading = false
        })
        //-------------------
        builder.addCase(getTonKhoBatch.pending, (state, action) => {
            console.log('Fetching todos from backend ....')
            state.Loading = true
        })
        builder.addCase(getTonKhoBatch.fulfilled, (state, action) => {
            console.log('Done')
            state.TonKhoBatch = action.payload
            state.Loading = false
        })
        builder.addCase(getTonKhoBatch.rejected, (state, action) => {
            console.log('Failed to get todos!!!')
            state.Loading = false
        })
        //----------------
        builder.addCase(getInStock.pending, (state, action) => {
            console.log('Fetching todos from backend ....')
            state.Loading = true
        })
        builder.addCase(getInStock.fulfilled, (state, action) => {
            console.log('Done')
            state.InStock = action.payload
            let Pro_2 = [];
            let Pro_4 = [];
            let Pro_2_4 = [];
            if (action.payload.length > 0) {
                //sum theo loai hang U_Pro_2
                (action.payload).reduce(function (res, value) {
                    if (!res[value.U_Pro_2]) {
                        res[value.U_Pro_2] = { U_Pro_2: value.U_Pro_2, Total: 0 };
                        Pro_2.push(res[value.U_Pro_2])
                    }
                    res[value.U_Pro_2].Total += value.Total;
                    return res;
                }, {});
                //Sắp xếp theo sản lượng giảm dần
                var sortQtyByPro2 = Pro_2.sort(function (a, b) {
                    return b.Total - a.Total;
                });
                state.InStockByPro2 = sortQtyByPro2;
                var topFivePro2 = sortQtyByPro2.slice(0, 6);

                //sum theo loai hang U_Pro_4
                (action.payload).reduce(function (res, value) {
                    if (!res[value.U_Pro_4]) {
                        res[value.U_Pro_4] = { U_Pro_4: value.U_Pro_4, Total: 0 };
                        Pro_4.push(res[value.U_Pro_4])
                    }
                    res[value.U_Pro_4].Total += value.Total;
                    return res;
                }, {});
                //Sắp xếp theo sản lượng giảm dần
                var sortQtyByPro4 = Pro_4.sort(function (a, b) {
                    return b.Total - a.Total;
                });
                state.InStockByPro4 = sortQtyByPro4;

                //sum theo loai hang U_Pro_2_4
                (action.payload).reduce(function (res, value) {
                    if (topFivePro2.some(e => { return e.U_Pro_2 === value.U_Pro_2 })) {
                        if (!res[value.U_Pro_2]) {
                            res[value.U_Pro_2] = { name: value.U_Pro_2, items: [] };
                            Pro_2_4.push(res[value.U_Pro_2])
                        }
                        if (!res[value.U_Pro_2].items.some(element => { return element.name === value.U_Pro_4 })) {

                            res[value.U_Pro_2].items.push({ value: 0, name: value.U_Pro_4 });
                            // console.log(Pro_2_4)
                            // Pro_2_4[].items.push(res[value.U_Pro_2].items[value.U_Pro_4])
                        }

                        res[value.U_Pro_2].items[res[value.U_Pro_2].items.findIndex(object => { return object.name === value.U_Pro_4; })].value += value.Total;
                    }
                    return res;

                }, {});
                state.InStockByPro2_4 = Pro_2_4;
            }
            else {
                state.InStockByPro2 = []
                state.InStockByPro4 = []
            }

            state.Loading = false
        })
        builder.addCase(getInStock.rejected, (state, action) => {
            console.log('Failed to get todos!!!')
            state.Loading = false
        })
    }
})

// Reducer
const TonKhoAVPReducer = TonKhoAVPSlice.reducer

// Selector
export const TonKhoAVPSelector = (state) => state.TonKhoAVPReducer
// Action export
export const {
} = TonKhoAVPSlice.actions

// Export reducer
export default TonKhoAVPReducer